/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsRequest,
  PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponse,
  PerfImpersonationPerformanceImpersonationProtocolsGetExportFileRequest,
  PerfImpersonationPerformanceImpersonationProtocolsGetExportFileResponse,
  PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsRequest,
  PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponse,
  PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsRequest,
  PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponse,
  PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeRequest,
  PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponse,
  PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsRequest,
  PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponse,
  PerfImpersonationPerformanceImpersonationProtocolsGetVisibleComponentResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PerformanceImpersonation<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PerformanceImpersonation
   * @name ImpersonationComponentListList
   * @request GET:/performance/impersonation/component-list
   */
  impersonationComponentListList = (params: RequestParams = {}) =>
    this.http.request<PerfImpersonationPerformanceImpersonationProtocolsGetVisibleComponentResponse, any>({
      path: `/performance/impersonation/component-list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceImpersonation
   * @name ImpersonationComponentFunnelChartsCreate
   * @request POST:/performance/impersonation/component/funnel-charts
   */
  impersonationComponentFunnelChartsCreate = (
    data: PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponse, any>({
      path: `/performance/impersonation/component/funnel-charts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceImpersonation
   * @name ImpersonationComponentInsightCreate
   * @request POST:/performance/impersonation/component/insight
   */
  impersonationComponentInsightCreate = (
    data: PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponse, any>({
      path: `/performance/impersonation/component/insight`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceImpersonation
   * @name ImpersonationComponentReportingCreate
   * @request POST:/performance/impersonation/component/reporting
   */
  impersonationComponentReportingCreate = (
    data: PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponse, any>({
      path: `/performance/impersonation/component/reporting`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceImpersonation
   * @name ImpersonationComponentComplianceCreate
   * @request POST:/performance/impersonation/component/compliance
   */
  impersonationComponentComplianceCreate = (
    data: PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponse, any>({
      path: `/performance/impersonation/component/compliance`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceImpersonation
   * @name ImpersonationComponentProcessingTimeCreate
   * @request POST:/performance/impersonation/component/processing-time
   */
  impersonationComponentProcessingTimeCreate = (
    data: PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponse, any>({
      path: `/performance/impersonation/component/processing-time`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceImpersonation
   * @name ImpersonationExcelCreate
   * @request POST:/performance/impersonation/excel
   */
  impersonationExcelCreate = (
    data: PerfImpersonationPerformanceImpersonationProtocolsGetExportFileRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfImpersonationPerformanceImpersonationProtocolsGetExportFileResponse, any>({
      path: `/performance/impersonation/excel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
